import { defineStore } from 'pinia'
import { useAppStore } from '@/stores'
import type { AccountSettingsSection } from '@/generated-api'
import { Capacitor } from '@capacitor/core'
import type { IDrawerList } from '@/src/interfaces/components/IDrawerList'

type SectionType = 'login' | 'contact' | 'notification'
const sectionStyles = {
  login: {
    icon: 'arrow-right-to-bracket',
    color: 'stone'
  },
  contact: {
    icon: 'address-book',
    color: 'sky'
  },
  notification: {
    icon: 'bell',
    color: 'red'
  }
}

export const useAccountSettingsStore = defineStore('accountSettings', () => {
  const appStore = useAppStore()
  const isNativePlatform = Capacitor.isNativePlatform()

  const getComputedSettings = (filterForNative: boolean): IDrawerList[] => {
    const content = appStore.content as AccountSettingsSection | undefined

    if (!content?.accountSettings) {
      return [{ title: content?.subTitle, list: [] }]
    }

    return [
      {
        title: content?.subTitle,
        list: Object.keys(content.accountSettings)
          .filter((key) => {
            if (filterForNative && key === 'notification' && !isNativePlatform) {
              return false
            }
            return true
          })
          .map((key) => {
            const item = content.accountSettings?.[key as SectionType]
            if (item) {
              const style = sectionStyles[item.sectionType as SectionType] || {}
              return {
                ...style,
                ...item
              }
            }
            return null
          })
          .filter(Boolean)
      }
    ]
  }

  return {
    getComputedSettings
  }
})
